import './utils/customerContinuityAuth';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/global.css';
import './styles/signin.css';
import './styles/managerDashboardReskin.css';
import './styles/adminOperationsBoard.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupGlobalFetchInterceptor } from './utils/fetchInterceptor';
import { initializeGoogleAnalytics } from './utils/googleAnalytics';
import ServerSeoSnapshotHandoff from './components/common/ServerSeoSnapshotHandoff';

// Setup global fetch interceptor for automatic logout on 401 errors
setupGlobalFetchInterceptor();
initializeGoogleAnalytics();

const scheduleIdleTask = (task, timeout = 1500) => {
  if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(task, { timeout });
    return;
  }
  setTimeout(task, timeout);
};

// Defer monitoring bootstrap so it doesn't compete with initial route rendering.
scheduleIdleTask(async () => {
  try {
    const { initializeSentryMonitoring } = await import('./monitoring/sentry');
    initializeSentryMonitoring();
  } catch (_error) {
    // no-op
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ServerSeoSnapshotHandoff />
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(async (metric) => {
  try {
    const { trackWebVital } = await import('./utils/analytics');
    trackWebVital(metric);
  } catch (_error) {
    // no-op
  }
});
